import React from 'react';
import {
  Typography,
  Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import ProductCard from '../../../components/ProductCard';
import { products } from '../../../data/products';
import PageLayout from '../../../components/PageLayout';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '1rem',
  textAlign: 'center',
});

const RingsPage = () => {
  const ringProducts = products.filter(product => product.category === 'rings');

  return (
    <PageLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageTitle>Rings</PageTitle>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          align="center"
          sx={{ mb: 6 }}
        >
          Discover our exquisite collection of rings, from classic designs to modern statements
        </Typography>

        <Grid container spacing={4}>
          {ringProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </PageLayout>
  );
};

export default RingsPage;
